export enum ParitySource{
  Manuel,
  Harem,
  Nadir,
  Kitco,
  Other
}
